import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import "./Test.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import TestDetail from "./TestDetail";
import girl from "../../images/girl.png";
import loadimg from "../../images/loader_wish.gif";
import { Helmet } from "react-helmet";

function Test({ token,slug, onNavHide }) {
  const navigate = useNavigate();

  const [testData, setTestData] = useState([]);

  const [BannerImage, setBannerImage] = useState("");

  const [currentIndex, setCurrentIndex] = useState(0);

  const [processIndex, setprocessIndex] = useState(0);

  const [processCount, setprocessCount] = useState(0);

  const [StartIndex, setStartIndex] = useState(0);

  const [testResults, setTestResults] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [AttentQuestion, setAttentQuestion] = useState(false);

  const [IsEasterEgg, setIsEasterEgg] = useState(false);

  const [Validate, setValidate] = useState(false);

  const [TestNote, setTestNote] = useState([]);

  const [TestName, setTestName] = useState([]);

  // const { slug } = useParams();

  const [isLoading, setIsLoading] = useState(true);

  const [seo, setSeo] = useState({});

  const [TestColor, setTestColor] = useState({});

  const [dimension_groups, setdimension_groups] = useState([]);

  const [showNormalLoader, setShowNormalLoader] = useState(true); 

  const [TestIntro, setTestIntro] = useState([]); 

  const [CalculationInfo, setCalculationInfo] = useState(null);

  useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }, []);


    useEffect(() => {

      const FetchCalculation = async () => {

        try {

          const cacheKey = `calculation_${slug}`;

          const savedCalculation =
            localStorage.getItem(cacheKey);

          if (savedCalculation) {

            const parsed =
              JSON.parse(savedCalculation);

            setCalculationInfo(parsed);

            return;
          }

          const response = await fetch(
            `${END_URL}/calculation/${slug}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          const data = await response.json();

          setCalculationInfo(data?.data);

          localStorage.setItem(
            cacheKey,
            JSON.stringify(data?.data)
          );

        } catch (error) {

          console.error(
            "Calculation fetch failed",
            error
          );
        }
      };

      if (slug) {
        FetchCalculation();
      }

    }, [slug]);


  useEffect(() => {
    const fetchTest = async () => {

      setShowNormalLoader(true);

      try {
        let url = `${END_URL}/fetch/test`;
        if (slug) {
          url += `/${slug}`;
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const ReponseData = response.data.test.category;

        const seoDate = response.data.seo_page;

        setSeo(seoDate);

        setTestNote(response.data.test_pop);

        setprocessCount(ReponseData.length);

        setTestData(ReponseData);

        setBannerImage(response.data?.test?.testdetail?.test_banner);

        setTestColor(response.data?.test?.testdetail);

        setdimension_groups(response.data?.dimension_groups || []);

        setTestIntro(response.data?.test?.testinfo);

        const testDetails = {
          id: response.data.test.id,
          slug: response.data.test.slug,
          name: response.data.test.name,
          type: response.data.test.type,
          result_test_name: response.data.test.result_test_name,
        };
        setTestName(testDetails);
      } catch (error) {
        console.error("Error fetching Test:", error);
      } finally {

        setShowNormalLoader(false); 
        setIsLoading(false); 
      }
    };

    fetchTest();
  }, [slug]);

  const handleResults = (results) => {
    const updatedResults = [...testResults];
    updatedResults[currentIndex] = results;
    setTestResults(updatedResults);
  };

  const handleSubmit = async () => {
    const currentTestItem = testResults[currentIndex];

    const isvalidate =
      currentTestItem?.questions.some(
        (question) => question.required === true && question.result === 0
      ) || false;

    if (currentTestItem && !isvalidate) {
      const unansweredQuestions = currentTestItem?.questions?.filter(
        (question) => question.result === 0
      );

      console.log(JSON.stringify(currentTestItem, null, 2));

      let leftsum = 0;
      let rigthsum = 0;

      currentTestItem?.questions.forEach((value) => {
        if (value.result < 0) {
          leftsum += Math.abs(value.result);
        } else {
          rigthsum += value.result;
        }
      });

      let totalquestions =
        100 *
          currentTestItem?.questions.filter(
            (question) => question.specialquestions === "N"
          ).length || 800;

      let total = leftsum + rigthsum;

      let neutral = totalquestions - total;

      let neutralpercent = (neutral / totalquestions) * 100;

      let leftpercent = (leftsum / totalquestions) * 100;

      let rightpercent = (rigthsum / totalquestions) * 100;

      if (
        (Math.round(leftpercent) === 50 && Math.round(rightpercent) === 50) ||
        Math.round(leftpercent) === Math.round(rightpercent)
      ) {
        setIsModalOpen(true);
      } else if (neutralpercent === 100) {
        setIsEasterEgg(true);
      } else {
        const updatedQuestions = currentTestItem.questions.map((question) => {
          return question;
        });

        const letter = leftpercent > rightpercent ? "left" : "right";

        const updatedTestItem = {
          ...currentTestItem,
          questions: updatedQuestions,
          letter: letter,
          left_result: leftpercent,
          right_result: rightpercent,
          answered: true,
        };

        const updatedTestResults = [...testResults];
        updatedTestResults[currentIndex] = updatedTestItem;
        setTestResults(updatedTestResults);

        const updatedTestData = [...testData];
        updatedTestData[currentIndex] = updatedTestItem;
        setTestData(updatedTestData);

        await SubmitTest(updatedTestData);
      }
    } else {
      setValidate(true);
    }
  };

  const SubmitTest = async (data) => {
    const result_data = data.map((item) => ({
      category_id: item.id,
      name: item.name,
      letter: item.letter,
      left_result: item.left_result,
      right_result: item.right_result,
      leftletter: item.leftletter,
      rightletter: item.rightletter,
      leftlabel: item.left_label,
      rightlabel: item.right_label,
    }));

    const result_letter = result_data.map((item) =>
      item.letter === "left" ? item.leftletter : item.rightletter
    );

    const slug = TestName.slug;

    const finalResult = result_letter.join("");

    const randomPart = Math.floor(Math.random() * 1e10);

    const test_slug = `${randomPart}-${slug}`;

    const test = {
      data: result_data,
      test: TestName,
      result: finalResult,
      test_slug: test_slug,
      slug: slug,
      type: "save_test",
    };

    // const slug = Math.random().toString(36).substring(2, 10);

    // const slug = result_letter.filter(Boolean).join('-').toLowerCase();

    // localStorage.setItem(slug, JSON.stringify(test));

    // console.log(localStorage.getItem(slug));

    // navigate(`/result/${slug}`);

    localStorage.setItem("handle_1", slug);

    localStorage.setItem("handle_2", test_slug);

    const SaveTest = async () => {
      try {
        const response = await axios.post(
          `${END_URL}/submit/test/${slug}/${test_slug}`,
          test,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        window.location.href = `${response.data.url}`;
      } catch (error) {
        console.error("Error sending result:", error);
      }
    };

    if (TestName.type == "free_test") {
      if (token) {
        SaveTest();
      } else {
        localStorage.setItem(slug, JSON.stringify(test));

        // navigate(`/result/${slug}/${test_slug}`);
         if (CalculationInfo) {
          
            localStorage.setItem(
              `calculation_${slug}`,
              JSON.stringify(CalculationInfo)
            );
          }

        window.location.href = `/result/${slug}/${test_slug}?calculating`;
      }
    } else {
      SaveTest();

    }

    // window.location.href = "/result/free-test";

    // const response = await axios.post(`${END_URL}/submit/test`, test, {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //         'Content-Type': 'application/json'
    //     }
    // });

    // console.log('Test submitted successfully:', response.data);
  };

  const handleNext = () => {
    // if (currentIndex < testData.length - 1) {
    //     setCurrentIndex(currentIndex + 1);
    // }

    const currentTestItem = testResults[currentIndex];

    const isvalidate =
      currentTestItem?.questions.some(
        (question) => question.required === true && question.result === 0
      ) || false;

    if (currentTestItem && !isvalidate) {
      const unansweredQuestions = currentTestItem?.questions?.filter(
        (question) => question.result === 0
      );

      // console.log(JSON.stringify(currentTestItem, null, 2));

      let leftsum = 0;
      let rigthsum = 0;

      currentTestItem?.questions.forEach((value) => {
        if (value.result < 0) {
          leftsum += Math.abs(value.result);
        } else {
          rigthsum += value.result;
        }
      });

      let totalquestions =
        100 *
          currentTestItem?.questions.filter(
            (question) => question.specialquestions === "N"
          ).length || 800;

      let total = leftsum + rigthsum;

      let neutral = totalquestions - total;

      let neutralpercent = (neutral / totalquestions) * 100;

      let leftpercent = (leftsum / totalquestions) * 100;

      let rightpercent = (rigthsum / totalquestions) * 100;

      let no_of_questions = currentTestItem?.questions.filter(
        (question) => question.specialquestions === "N"
      ).length;

      let no_of_answered = currentTestItem?.questions.filter(
        (question) =>
          question.specialquestions === "N" && question.answered === true
      ).length;

      if (no_of_questions != no_of_answered) {
        setAttentQuestion(true);
      } else if (
        (Math.round(leftpercent) === 50 && Math.round(rightpercent) === 50) ||
        Math.round(leftpercent) === Math.round(rightpercent)
      ) {
        setIsModalOpen(true);
      } else if (neutralpercent === 100) {
        setIsEasterEgg(true);
      } else {
        const updatedQuestions = currentTestItem.questions.map((question) => {
          return question;
        });

        const letter = leftpercent > rightpercent ? "left" : "right";

        const updatedTestItem = {
          ...currentTestItem,
          questions: updatedQuestions,
          letter: letter,
          left_result: leftpercent,
          right_result: rightpercent,
          answered: true,
        };

        const updatedTestResults = [...testResults];
        updatedTestResults[currentIndex] = updatedTestItem;
        setTestResults(updatedTestResults);

        const updatedTestData = [...testData];
        updatedTestData[currentIndex] = updatedTestItem;
        setTestData(updatedTestData);

        setStartIndex(0);

        if (currentIndex < testData.length - 1) {
          setCurrentIndex(currentIndex + 1);
        }
      }
    } else {
      setValidate(true);
    }

    if (currentIndex >= processIndex) {
      setprocessIndex(currentIndex + 1);
    }
  };

  const handleModalClose = () => {
    const currentTestItem = testResults[currentIndex];

    let changed = false;

    const updatedQuestions = currentTestItem.questions.map((question) => {
      if (question.specialquestions === "Y" && !changed) {
        changed = true;
        return {
          ...question,
          specialquestions: "N",
          required: true,
          answered: true,
        };
      }
      return question;
    });

    const updatedTestItem = {
      ...currentTestItem,
      questions: updatedQuestions,
    };

    const updatedTestResults = [...testResults];
    updatedTestResults[currentIndex] = updatedTestItem;

    setTestResults(updatedTestResults);

    const updatedTestData = [...testData];
    updatedTestData[currentIndex] = updatedTestItem;
    setTestData(updatedTestData);
    // console.log(JSON.stringify(updatedTestData, null, 2),'handle fun');

    setIsModalOpen(false);
  };

  const handleEasterEgg = () => {
    setIsEasterEgg(false);
  };

  const handleValidate = () => {
    setValidate(false);
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleAttendClose = () => {
    setAttentQuestion(false);
  };

  // console.log(testResults, 'testResults');

  if (showNormalLoader) {
    return (
      <div className="loader-container">
        <img src={loadimg} alt="Loading..." className="loader-gif" />
      </div>
    );
  }


  return (
    <>
      <Helmet>
        <title>
          {seo?.meta_title ||
            "Personality Assessment Test with Models | Personality Peek "}
        </title>

        <meta
          name="description"
          content={
            seo?.meta_description ||
            "Try our free personality assessment test to uncover your traits, strengths, and archetype. Fun, fast, and insight-driven results"
          }
        />

        <meta
          name="keywords"
          content={
            seo?.meta_keywords ||
            "personality assessment test , personality test"
          }
        />

        {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
        {seo?.og_description && (
          <meta property="og:description" content={seo.og_description} />
        )}
        {seo?.og_image && (
          <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
        )}
        {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
        {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

        {seo?.twitter_title && (
          <meta name="twitter:title" content={seo.twitter_title} />
        )}
        {seo?.twitter_description && (
          <meta name="twitter:description" content={seo.twitter_description} />
        )}
        {seo?.twitter_image && (
          <meta
            name="twitter:image"
            content={`${IMG_URL}/d0/${seo.twitter_image}`}
          />
        )}
        {seo?.twitter_card && (
          <meta name="twitter:card" content={seo.twitter_card} />
        )}

        {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

        {!seo?.og_title && (
          <meta
            property="og:title"
            content="PersonalityTest - Discover Your True Archetype | Personality Peek"
          />
        )}
        {!seo?.og_description && (
          <meta
            property="og:description"
            content="Try our free personality assessment test to uncover your traits, strengths, and archetype. Fun, fast, and insight-driven results"
          />
        )}
        {!seo?.og_type && <meta property="og:type" content="website" />}
        {!seo?.twitter_card && (
          <meta name="twitter:card" content="summary_large_image" />
        )}
      </Helmet>

      <div className="test-main">
   
          <>
            {testData && testData.length > 0 && (
              <>
                <TestDetail
                  TestColor={TestColor}
                  onNavHide={onNavHide}
                  processCount={processCount}
                  currentindex={processIndex}
                  startindex={StartIndex}
                  testItem={testData[currentIndex]}
                  BannerImage={BannerImage}
                  handleResults={handleResults}
                  slug={slug}
                  dimension_groups={dimension_groups}
                  TestIntro={TestIntro}
                />

                <div className="row test-button-row">
                  {currentIndex > 0 && (
                    <a
                      className="test-box-a test-box-p"
                      onClick={handlePrevious}
                    >
                      <span className="test-box-a-icon">
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </span>
                      <span className="test-box-a-text">Previous</span>
                    </a>
                  )}

                  {currentIndex < testData.length - 1 && (
                    <a className="test-box-a" onClick={handleNext}>
                      <span className="test-box-a-text">Next</span>
                      <span className="test-box-a-icon">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  )}

                  {currentIndex === testData.length - 1 && (
                    <a className="test-box-a test-subt" onClick={handleSubmit}>
                      <span className="test-box-a-text">Submit</span>
                      <span className="test-box-a-icon">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  )}
                </div>
              </>
            )}

            {isModalOpen && (
              <div className="modal-question">
                <div className="modal-test">
                  <div className="modal-content-test">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: TestNote?.attend_new_question,
                      }}
                    />

                    <button
                      className="modal-close-button-test"
                      onClick={handleModalClose}
                    >
                      Ok
                    </button>
                    <img src={girl} alt="" />
                  </div>
                </div>
              </div>
            )}

            {IsEasterEgg && (
              <div className="modal-question">
                <div className="modal-test">
                  <div className="modal-content-test">
                    <p>Easter Egg !</p>
                    <button
                      className="modal-close-button-test"
                      onClick={handleEasterEgg}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            )}

            {Validate && (
              <div className="modal-question">
                <div className="modal-test">
                  <div className="modal-content-test">
                    <p> Atleast Answer this Question !</p>
                    <button
                      className="modal-close-button-test"
                      onClick={handleValidate}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            )}

            {AttentQuestion && (
              <div className="modal-question">
                <div className="modal-test">
                  <div className="modal-content-test">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: TestNote?.test_message_note,
                      }}
                    />

                    <button
                      className="modal-close-button-test"
                      onClick={handleAttendClose}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        {/* // )} */}
      </div>
    </>
  );
}

export default Test;
